<template>
	<div class="contract-list">
		<el-row class="filter-wrap" :gutter="20">
			<el-col :span="5">
				<el-input clearable v-model="page.ourCode" size="small" placeholder="外付合同编号（我方）" @keyup.enter.native="onSearch">
				</el-input>
			</el-col>
			<el-col :span="5">
				<el-input clearable v-model="page.brandContractQueryStr" size="small" placeholder="所属品牌合同名称/编号" @keyup.enter.native="onSearch">
				</el-input>
			</el-col>
			<el-col :span="5">
				<el-input clearable v-model="page.sealApplyUserName" size="small" placeholder="盖章申请人" @keyup.enter.native="onSearch">
				</el-input>
			</el-col>
			<el-col :span="4" class="input-group">
				<el-select v-model="page.costType" @change="getList()" clearable size="small" placeholder="未选择外付成本类型" class="w-100">
					<el-option v-for="(item,index) in costType" :key="index" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-col>

			<el-col :span="4">
				<el-button type="primary" size="small" @click="onSearch">查询</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 30px;">待盖章合同总数：{{page.total||0}}条</div>
		<div class="table-wrap">
			<el-table v-loading="tableLoading" :data="tableData" size="small">
				<el-table-column label="外付合同编号（我方）" prop="ourCode" align="center"></el-table-column>
				<el-table-column label="外付合同附件" prop="fileList" align="center">
					  <template slot-scope="scope">
						<filePreview :fileList="scope.row.fileList"></filePreview>
						<!-- <a style="display: block;" v-for="(item,index) in scope.row.fileList" :key='index' class="link" href="javascript:void(0);" @click="downloadFile(item.path,item.name)" :download="item.path">{{item.name}}</a> -->
						<span v-if="scope.row.fileList == null">--</span>
					  </template>
				</el-table-column>
				<el-table-column label="外付成本类型" prop="costType" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.costType==1">外包服务</span>
							<span v-else-if="scope.row.costType==2">媒介采买</span>
							<span v-else-if="scope.row.costType==3">杂费</span>
							<span v-else-if="scope.row.costType==4">内部采买</span>
					</template>
				</el-table-column>
				<el-table-column label="外付金额" prop="money" align="center"></el-table-column>
				<el-table-column label="盖章类型" prop="sealType" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.sealType==0">不盖章</span>
							<span v-else-if="scope.row.sealType==1">公章</span>
							<span v-else-if="scope.row.sealType==2">合同章</span>
					</template>
				</el-table-column>
				<el-table-column label="盖章经办人" prop="sealOperatorName" align="center"></el-table-column>
				<el-table-column label="所属品牌合同" prop="sealApplyUserName" align="center"></el-table-column>
				<el-table-column label="盖章申请人" prop="sealApplyUserName" align="center"></el-table-column>
				<el-table-column label="盖章申请时间" prop="sealApplyTime" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text"  size="small" @click='goel(scope.row.id)'>查看</el-button>
						<template v-if="permissions.outPay_stamped">
							<el-button type="text" size="small" @click="deleteOne(scope.row.id)">盖章</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-wrap">
				<el-pagination background @size-change="sizeChange" @current-change="currentChange"
					:current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
					layout="sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
			<!-- 分页 -->
		</div>
		<!-- 外付合同详情 -->
		<el-dialog title="外付合同详情" :visible.sync="Invoicedialog" label-width="120px">
			<div style="margin-top:-30px;">
			  <h4>合同附件信息：</h4>
			  <div class="diaList">
			    <div class="valList">
			      <div>合同附件：</div>
			      <div>
			        <div></div>
					<filePreview :fileList="InvoiceForm.fileList" :modalShow="false"></filePreview>
			        <!-- <div v-for="(item, index) in InvoiceForm.fileList" :key="index">
			          <a style="width: 150px;" class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.path">{{ item.name }}</a>
			        </div> -->
			      </div>
			    </div>
			    <div class="valList">外付成本类型：{{costTypeList[InvoiceForm.costType]}}</div>
			    <div class="valList">外付公司名称：{{InvoiceForm.brandSupplierName}}</div>
			    <div class="valList">外付金额：{{InvoiceForm.money}}</div>
			    <div class="valList">外付合同编号（我方）：{{InvoiceForm.ourCode}}</div>
			    <div class="valList">外付合同编号（乙方）：{{InvoiceForm.secondPartyCode}}</div>
			    <div class="valList">签订时间：{{InvoiceForm.signTime?InvoiceForm.signTime.substr(0,10):''}}</div>
			    <div class="valList">结束时间：{{InvoiceForm.endTime?InvoiceForm.endTime.substr(0,10):''}}</div>
			    <div class="valList">返点比例：{{InvoiceForm.rebateRatio}}</div>
			    <div class="valList">盖章类型：{{sealTypeList[InvoiceForm.sealType]}}</div>
			    <div class="valList">盖章经办人：{{InvoiceForm.sealOperatorName}}</div>
			    <div class="valList"></div>
			    <div class="valList">
			      <div>合同扫描件：</div>
			      <div>
			        <div></div>
					<filePreview :fileList="InvoiceForm.scannedCopyList" :modalShow="false"></filePreview>
			        <!-- <div v-for="(item, index) in InvoiceForm.scannedCopyList" :key="index">
			          <a style="width: 150px;" class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.path">{{ item.name }}</a>
			        </div> -->
			      </div>
			    </div>
			    <div class="valList">创建人：{{InvoiceForm.createUserName}}</div>
			    <div class="valList">创建时间：{{InvoiceForm.createTime}}</div>
			    <div class="valList">所属品牌合同：{{InvoiceForm.brandContractName}}</div>
			    <div class="valList">合同负责人：{{InvoiceForm.businessPrincipalName}}</div>
			    <div class="valList"></div>
			    <div class="valList">盖章状态：{{sealStatusList[InvoiceForm.sealStatus]}}</div>
			    <div class="valList">盖章申请人：{{InvoiceForm.sealApplyUserName}}</div>
			    <div class="valList">盖章申请时间：{{InvoiceForm.sealApplyTime}}</div>
			    <div class="valList">盖章人：{{InvoiceForm.sealUserName}}</div>
			    <div class="valList">盖章时间：{{InvoiceForm.sealTime}}</div>
			    <div class="valList"></div>
			    <div class="valList" v-if="InvoiceForm.sealStatus == 6">作废人：{{InvoiceForm.voidUserName}}</div>
			    <div class="valList" v-if="InvoiceForm.sealStatus == 6">作废时间：{{InvoiceForm.voidTime}}</div>
			    <div class="valList" style="width:300px;" v-if="InvoiceForm.sealStatus == 6">
			      <div style="width:110px;">作废原因：</div>
			      <div style="width:300px;">{{InvoiceForm.voidReason}}</div>
			    </div>
			  </div>
			  <h4>审批详情：</h4>
			  <div>
			    <div class="spDetal">审批人：{{InvoiceForm.approverName}}</div>
			    <div class="spDetal" v-if="InvoiceForm.approverNameList">(可审批人：<span v-for="(item,index) in InvoiceForm.approverNameList" :key="index">{{item}},</span> )</div>
			    <div class="spDetal">审批状态：{{auditStatusList[InvoiceForm.auditStatus]}}</div>
			    <div class="spDetal">审批备注：{{InvoiceForm.auditRemark}}</div>
			  </div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as qiniu from "qiniu-js"; 
	import { qiniuToken } from "@/api/index";
	import XLSX from "xlsx";
	import {
		mapGetters
	} from "vuex";
	import validate from "@/util/validate";
	import util from "@/util/util";
	import {
		contractConfig
	} from "@/const/config/contract";
	import InvoiceFormFields from "@/const/form/InvoiceForm";
	import {
		billingConfig
	} from "@/const/config/billing";
	import {
		sealList,clickSeal,wfInfo
	} from "./index.js";
	import {
		processList
	} from "@/api/approve/contract";
	import approveList from "@/components/common/approveMember";
	export default {
		components: {

		},
		data() {
			// 开票金额判断
			var validPrice = (rule, value, callback) => {
				let money = this.remainingMoney;
				if (!validate.checkNull(value)) {
					let err = validate.checkAmount(value, money);
					if (err) {
						callback(new Error(err));
					}
					callback();
				}
				callback();
			};
			return {
				costTypeList:['','外包服务','媒介采买','杂费','内部采买'],
				sealTypeList:["不盖章","公章","合同章"],
				sealStatusList:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
				auditStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过'],
				
				fileData:null,//导入文件
				fileName:'',//文件名称
				voucher:'',//上传回款凭证
				drBack:{},//导入返回数据
				drhkStatus:false,//导入状态开关
				hkid:'',//合同id
				zfForm:{
					"id":null,
					"returnMoneyId":null,
					"contractId": null,
					"reason":"",
					"deleteFlag": 0
				},
				costType:[
						  {label:'外包服务',value:1},
						  {label:'媒介采买',value:2},
						  {label:'杂费',value:3},
						  {label:'内部采买',value:4},
				],//回款类型
				sealType:[
					{label:'不盖章',value:0},
					{label:'公章',value:1},
					{label:'合同章',value:2},
				],//
				sealStatus:[
						  {label:'不盖章',value:0},
						  {label:'待申请盖章',value:1},
						  {label:'盖章审核中',value:2},
						  {label:'盖章审核不通过',value:3},
						  {label:'待盖章',value:4},
						  {label:'已盖章',value:5},
						  {label:'已作废',value:6},
				],
				auditStatus:[
					{label:'待直属上级审批',value:1},
					{label:'直属上级审批不通过',value:2},
					{label:'直属上级审批通过',value:3},
				],//审批状态
				zfData:{},//作废信息
				rlData:[],//认领记录
				fileList: [], //凭证
				billingConfig,
				uphkVisible:false,//上传回款凭证
				approveVisible: false,
				approveLoading: false,
				Invoicedialog: false, //回款详情
				approveTitle: false,
				invoiceVisible: false, //作废详情
				zftxVisible: false, //作废提醒
				drhkVisible: false, //导入回款
				/**
				 * 开票提醒模块
				 */
				isUploadFile: false, //是否上传
				hasCorrectIncome: false, //KOL收入+有花果收入=净收入
				hasRemainingMoney: false, //剩余金额大于可开票金额


				contractConfig: contractConfig,
				form: {
					nameOrCode: "",
					customerName: "",
					contractMoneyMin: "",
					contractMoneyMax: "",
					statusList: "",
				},
				  InvoiceForm: {
						// account: "",
						// bankAccount: null,
						// bankDeposit: "",
						// bankSerialNumber: "",
						// claimMoney: null,
						// createTime: "",
						// createUserId: "",
						// createUserName: "test",
						// deleteFlag: null,
						// payeeName: "",
						// payer: "",
						// remark: "",
						// returnMoney: 0,
						// returnTime: "",
						// returnType: 1,
						// status: 1,
						// voucher: "",
						// waitClaimMoney: 0,
				  },
				rules: {
					invoiceMoney: [{
							required: true,
							message: "请输入合同金额",
							trigger: "blur"
						},
						{
							validator: validPrice,
							trigger: "blur"
						},
					],
				},
				  page: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
					sealStatus:4,
					brandContractQueryStr:'',//品牌合同名称/编号
					costType:null,//成本类型（1-外包服务；2-媒介采买；3-杂费；4-内部采买）
					sealApplyUserName:'',//盖章申请人姓名
					ourCode:'',//外附合同编号（我方）
				  },
				  rlpage:{
				  		  pageNum: 1,
				  		  pageSize: 5,
				  		  total: 0,
				  },//认领列表分页
				submitLoading: false,
				tableData: [],
				tableLoading: false,
				/**
				 * 业务负责人模块
				 */
				adminListModal: false,
				adminPage: {
					pageSize: 10,
					pageNum: 1,
					total: 0,
				},
				adminForm: {
					queryString: "",
				},
				selectAdminId: null,
				selectAdmin: null,
				adminTable: [],
				adminTableLoading: false,
				pid: null,
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			...mapGetters(["permissions", "dicts"]),
		},
		methods: {
			//重新shenqing
			sqAgain(id){
				this.$parent.activeIndex = 'list2'
				this.$parent.restId = id
			},
			//点击导入
			drSubmit(){
				if(this.fileData == null){
					this.$message({
					  message: '请先上传回款文档',
					  type: 'warning'
					});
					return
				}
				let formData = new FormData();
				console.log('我是点击的data',this.fileData)
				console.log(this.fileData.name)
				formData.append("file",this.fileData);
				console.log('1111',formData)
				drSub(formData)
				 .then((res) => {
					if(res.code==1){
						this.drBack = res.data
						this.drhkVisible = false
						this.drhkStatus = true
						this.fileData = null
						this.fileName = ''
					}
				 })
				 .catch((err) => {
									  			
				 });
			},
			//清除上传文件
			cleanWord(){
				this.voucher = '';
			},
			//获取文件后缀名
			getWordname(str){
				var index = str.lastIndexOf("\/");  
				str  = str.substring(index + 1, str .length);
				return str
			},
			//点击回款凭证
			uploadHkpz(row){
				this.hkid = row.id
				this.voucher = row.voucher
				this.uphkVisible = true
			},
			//回款凭证上传获取路径
			beforeUpload2(file){
						 console.log(1111111,file)
						  qiniuToken()
						    .then((res) => {
						      let that = this;
						      let fileName = Date.now() + file.name;
						      var observable = qiniu.upload(file, fileName, res.data);
						      observable.subscribe({
						        next(res) {
						          console.log("upload...", res);
						        },
						        error(error) {
						          this.$message.error("上传失败");
						          console.log("error", error);
						        },
						        complete: (complete) => {
						          console.log("complete");
						          let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
						          this.$set(this.form, "fileName", file.name);
						          this.$set(this.form, "path", qiniuBaseUrl + complete.key);
								  console.log(qiniuBaseUrl + complete.key)
									  this.voucher = qiniuBaseUrl + complete.key
			
						        },
						      });
						    })
						    .catch((error) => {});
						  return false;
						},
			//提交回款凭证
			SubmitHkpz(){
				const obj = { 
					id:this.hkid,
					voucher:this.voucher
				}
				editHkpz(obj)
				  .then((res) => {
						if(res.code == 1){
							this.$message({
							  message: '修改成功',
							  type: 'success'
							});
						}
					this.uphkVisible = false
					this.getList();
					this.voucher = '';
				  })
				  .catch((err) => {
							
				  });
			},
			//导出失败回款
			dcFalse(){
				dcHk(this.drBack.falseObject)
				  .then((res) => {
					const blob = new Blob([res.data]);
					let fileName = res.headers["content-disposition"].split("filename=")[1];
					fileName = decodeURI(fileName);
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					  window.navigator.msSaveOrOpenBlob(blob, fileName);
					} else {
					  const linkNode = document.createElement("a");
					  linkNode.download = fileName; //a标签的download属性规定下载文件的名称
					  linkNode.style.display = "none";
					  linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
					  document.body.appendChild(linkNode);
					  linkNode.click(); //模拟在按钮上的一次鼠标单击
					  URL.revokeObjectURL(linkNode.href); // 释放URL 对象
					  document.body.removeChild(linkNode);
					}
					
					setTimeout(() => {
					  this.$message.success("导出成功，等待文件下载完毕");
					}, 500);
					this.drhkStatus = false
				  })
				  .catch((err) => {
							
				  });
			},
			//确认作废
			zfSubmit(){
				zfZl(this.zfForm)
				  .then((res) => {
						if(res.code == 1){
							this.$message({
							  message: '作废成功',
							  type: 'success'
							});
						}
					this.zftxVisible = false
				  })
				  .catch((err) => {
							
				  });
			},
			//作废信息
			zfInfo(id){
				this.invoiceVisible = true
				zfInfoApi(id)
				  .then((res) => {
						console.log('我是作废信息',res)
						this.zfData = res.data
				  })
				  .catch((err) => {
							
				  });
			},
			//上传方法
		 beforeUpload(file){
			 this.fileData = file
			 console.log('我是上传后的file',file)
			 this.fileName = file.name
			this.$forceUpdate()
			},
			// 盖章弹框
			deleteOne(id) {
				this.$confirm('确认盖章吗?', '提示', {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning'
				}).then(() => {
					var obj = {
						id : id
					}
					clickSeal(obj)
					  .then((res) => {
							if(res.code==1){
								this.getList();
								this.$message({
									type: 'success',
									message: '盖章成功!',
								});
								setTimeout(()=>{
									this.$router.go(0)
								},500)
							}
					  })
					  .catch((err) => {
								
					  });
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//读取操作
			readXLSX(file) {
			  let nameSplit = file.name.split(".");
			  let format = nameSplit[nameSplit.length - 1];
			  if (!["xlsx", "csv"].includes(format)) {
			    return false;
			  }
			  return new Promise((resolve, reject) => {
			    let reader = new FileReader();
			    reader.readAsBinaryString(file);
			    reader.onload = evt => {
			      let data = evt.target.result; // 读到的数据
			      let workbook = XLSX.read(data, { type: "binary" });
				  data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]) //转成 json 数据
				  console.log(data)
			      resolve(workbook);

			    };
			  });
			},
			//导入回款
			dzhk() {
				this.drhkVisible = true
			},
			//查看详情
			goel(id) {
				this.Invoicedialog = true
				wfInfo(id)
					.then((res) => {
							this.InvoiceForm  = res.data
					})
					.catch((err) => {
							
					});
			},
			//查看关联合同
			gogl(id) {
				let router = this.$router.resolve({
					path: "/brand/brandList/edit",
					query: {
						id: id,
						isgl:true
					},
				});
				window.open(router.href, "_blank");
			},
			// 查看详情
			lookInfo(id){
			  this.Invoicedialog = true

			},
			//打开认领记录
			openrlList(id){
					this.approveVisible = true
					this.hkid = id
					this.getRl();
			},
			// 获取认领记录
			getRl(){
				let obj = {
					id:this.hkid,
					pageNum:this.rlpage.pageNum,
					pageSize:this.rlpage.pageSize,
				}
				rlList(obj)
				  .then((res) => {
						console.log('我是认领记录',res)
						this.rlData = res.data
						this.rlpage.total = res.total;
						console.log('我是认领记录总数',this.rlpage.total)
				  })
				  .catch((err) => {
							
				  });
			},
			//点击作废
			zfClick(row) {
				console.log(row)
				this.zfForm.contractId = row.contractId
				this.zfForm.id = row.id
				this.zfForm.returnMoneyId = row.returnMoneyId
				this.zftxVisible = true
			},
			// 上传凭证
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			/**重新提交 */
			reSubmit(contractId) {
				this.$confirm("确认重新提交启动审批?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						reapply({
							contractId
						}).then((res) => {
							this.$message.success("重新提交成功");
							this.getList();
						});
					})
					.catch(() => {});
			},
			/**
			 * 业务负责人模块
			 */
			//打开资源选择弹窗
			onOpenAdminSelectModal(username, id, pid) {
				if (username) {
					this.selectAdmin = {
						username,
						id,
					};
				} else {
					this.selectAdmin = null;
				}
				this.pid = pid;
				this.adminListModal = true;
			},
			//资源选择弹窗打开
			openAdminSelectModal() {
				this.adminForm.queryString = "";
				this.selectAdminId = null;
				this.onAdminSearch();
			},
			//资源标签删除
			onAdminTagClose() {
				this.selectAdmin = null;
				this.selectAdminId = null;
			},
			//资源弹窗关闭
			onConfirmAdminChoose() {
				if (this.selectAdmin) {
					let obj = {
						businessPrincipalId: this.selectAdmin.id,
						contractId: this.pid,
					};
					editAdmin(obj)
						.then((res) => {
							if (res.code == 1) {
								this.$message.success("分配成功！");
								this.getList();
							}
						})
						.catch((err) => {});
					this.adminListModal = false;
				} else {
					this.$message.error("不能删除业务负责人！");
				}
			},
			/**认领列表
			 * 监听分页器每页显示的条数变化
			 * @param val 条数
			 */
			rlSizeChange(val) {
			  this.rlpage.pageNum = 1;
			  this.rlpage.pageSize = val;
			  this.getRl();
			},
			/**认领列表
			 * 监听页数变化
			 * @param val 当前页数
			 */
			rlCurrentChange(val) {
			  this.rlpage.pageNum = val;
			  this.getRl();
			},
			//资源搜索
			onAdminSearch() {
				this.adminPage.pageNum = 1;
				this.getAdminList();
			},
			//获取资源列表
			getAdminList() {
				let obj = {
					pageSize: this.adminPage.pageSize,
					pageNum: this.adminPage.pageNum,
				};
				if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
					obj.usernameOrPhone = this.adminForm.queryString.trim();
				}
				this.adminTableLoading = true;
				listAdmin(obj)
					.then((res) => {
						this.adminTable = res.data || [];
						this.adminPage.total = res.total;
						this.adminTableLoading = false;
					})
					.catch((err) => {
						this.adminTable = [];
						this.adminPage.total = 0;
						this.adminTableLoading = false;
					});
			},
			//资源选择变化
			onChangeAdmin(val) {
				console.log(this.selectAdminId);
				this.selectAdmin = this.adminTable.find((v) => v.id == val);
			},

			//提交
			onSubmit() {
				this.$refs.InvoiceForm.validate((valid, obj) => {
					if (valid) {
						let f = util.deepClone(this.InvoiceForm);
						InvoiceAdd(f).then((res) => {
							if (res.code == 1) {
								this.$message.success("申请成功！");
								this.Invoicedialog = false;
								this.getList();
							}
						});
					} else {
						let a = Object.keys(obj).map((v) => {
							let text = "";
							if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
								let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
								text = InvoiceFormFields.list[fieldInArray];
							} else {
								text = InvoiceFormFields.list[v];
							}
							return text;
						});
						this.$message.error(
							"表单不完整！请检查" + a.join("、") + "是否按要求填写"
						);
					}
				});
			},
			/**
			 * 监听分页器每页显示的条数变化
			 * @param val 条数
			 */
			sizeChange(val) {
				this.page.pageNum = 1;
				this.page.pageSize = val;
				this.getList();
			},
			/**
			 * 监听页数变化
			 * @param val 当前页数
			 */
			currentChange(val) {
				this.page.pageNum = val;
				this.getList();
			},

			// 搜索
			onSearch() {
				if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
					if (
						parseInt(this.form.contractMoneyMin) >
						parseInt(this.form.contractMoneyMax)
					) {
						this.$message.error("最小合同金额不能大于最大合同金额");
						return;
					}
				}
				this.page.pageNum = 1;
				this.getList();
			},
			// 获取列表
			getList() {
			  this.tableLoading = true;
			  sealList(this.page)
				.then((res) => {
					console.log(res)
				  this.tableData = res.data || [];
				  this.page.total = res.total;
				  this.tableLoading = false;
				})
				.catch((err) => {
					
				});
			},
			/**
			 * 数字可读化
			 * @param num 数字
			 */
			readableNum(num) {
				if (!num && num !== 0) return "";
				return util.priceFormat(num);
			},
		},
		watch: {
			Invoicedialog(val) {
				if (!val) {
					this.InvoiceForm = {
						contractId: null, //合同ID
						customerName: "", //名称
						companyPhone: "", //电话
						companyAddress: "", //公司地址
						taxpayerId: "", //纳税人识别号
						customerBank: "", //客户开户行
						customerBankAccount: "", //客户银行账户
						invoiceMoney: "", //开票金额
						invoiceType: "", //发票类型
						invoiceDetail: "", //开票明细
						remark: "", //合同备注
					};
					// this.$refs.InvoiceForm.clearValidate("invoiceMoney");
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.diaList {
	  width: 100%;
	  display: flex;
	  -webkit-flex-wrap: wrap;
	  .valList {
	    width: 30%;
	    margin: 5px 0;
	    margin-right:8px;
	    display: flex;
	
	  }
	}
	.chaochu {
	  display: -webkit-box;
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 1;
	  overflow: hidden;
	}
	.spDetal{
	  margin: 5px 0;
	}
	.dz-img {
		display: block;
		width: 90px;
		height: 100px;
		margin: 0 auto;
	}

	.dz-title {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		text-align: center;
		padding: 10px;
	}

	.dz-text {
		text-align: center;
		padding: 20px;
	}

	.dz-info {
		display: flex;
		justify-content: space-around;
		padding: 20px;
	}

	.table-wrap {
		margin-top: 20px;
	}

	.mar-c {
		display: flex;
		justify-content: center;
	}

	.table-count {
		margin: 15px 0 10px;
	}

	// 列表item
	.block-form-item {
		&.w-32 {
			display: inline-block;
			width: 32%;
			margin-right: 1%;
			height: 64px;
		}

		&.w-99 {
			width: 99%;
			margin-right: 1%;
		}
	}

	.yhg-dialog {
		.select-con {
			display: flex;

			.label {
				white-space: nowrap;
			}

			.select-tag {
				margin-right: 5px;
				margin-bottom: 5px;
			}

			.select-tag-text {
				display: inline-block;
				max-width: 86px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.filter-con {
			display: flex;
			align-items: center;
			margin: 20px 0;
			width: 800px;

			.label {
				white-space: nowrap;
			}

			.search-btn {
				margin-left: 15px;
			}
		}

		.submit-con {
			margin-top: 20px;
			text-align: right;
		}
	}

	.select-input-wrap-s {
		.el-input-group__append {
			position: relative;
			width: 32px;
			height: 32px;
			border: none;
			background: #fff;
			padding: 0;
			color: #409eff;

			.iconfont {
				position: absolute;
				top: -2px;
				left: -1px;
				font-size: 33px !important;
			}

			cursor: pointer;
		}
	}

	.select-con {
		.el-tag .el-icon-close {
			top: -8px;
		}
	}

	.avue-view .cost-table {
		width: calc(50% + 100px);

		th {
			background: none;
			font-weight: normal;
			font-size: 14px;
		}

		.cell {
			padding-left: 0;
		}
	}

	.el-table .operate-column {
		vertical-align: text-top;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #ccc !important;
	}

	.invoiceList {
		display: flex;
		justify-content: space-between;
	}

	.mt-10 {
		margin-top: 10px;
	}
</style>
<style>
	.el-dialog {
	    width: 70%;
	}
	.el-icon-delete-solid:hover{
		color: #66B1FF;
	}
	.el-icon-delete-solid{
		cursor: pointer;
	}
</style>
